<script setup>
import StrapFinderConfiguratorReplace from '@maison/components/strapFinder/StrapFinderConfiguratorReplace.vue';
import StrapFinderConfiguratorCustomize from '@maison/components/strapFinder/StrapFinderConfiguratorCustomize.vue';
import { useI18n } from 'vue-i18n';

defineProps({
  buckleTypeSection: {
    type: Object,
    required: true,
  },
  strapStyleSection: {
    type: Object,
    required: true,
  },
  strapSection: {
    type: Object,
    required: true,
  },
  strapSizeSection: {
    type: Object,
    required: true,
  },
  buckleSection: {
    type: Object,
    required: true,
  },
  summarySection: {
    type: Object,
    required: true,
  },
  replaceSection: {
    type: Object,
    required: true,
  },
});

const url = new URL(window.location.href);
const reference = url.searchParams.get('reference');
const { t } = useI18n();

if (!reference) {
  window.Phoenix.notification.create(t('StrapFinderConfigurator.errors.noReference'), 'error');
  window.location.href = window.route('strap_finder_search_page');
}

const isReplace = !!url.searchParams.get('replace');
</script>

<template>
  <template v-if="reference">
    <strap-finder-configurator-replace v-if="isReplace" :reference="reference" :replace-section="replaceSection" />
    <strap-finder-configurator-customize
      v-else
      :reference="reference"
      :buckle-type-section="buckleTypeSection"
      :strap-style-section="strapStyleSection"
      :strap-section="strapSection"
      :strap-size-section="strapSizeSection"
      :buckle-section="buckleSection"
      :summary-section="summarySection"
    />
  </template>
</template>
